import React from 'react'
import { Table } from "reactstrap"
import { Link } from "react-router-dom"
import TableLoader from 'components/TableLoader'
import moment from 'moment'

export default function (props) {
  const { items, isLoading, currentOrder, changeOrder, id } = props

  const requestTypesWithExtendedFlow = [
    'consultorio',
    'consultorio_baja',
    'consultorio_renovacion',
  ];

  const getIconClassBySorted = (field) => {
    if (currentOrder.field === field) {
      if (currentOrder.dir === -1) {
        return 'fa fa-caret-down'
      } else {
        return 'fa fa-caret-up'
      }
    }

    return 'fas fa-sort'
  }

  const getStateName = (id, type) => {
    switch(id) {
      case 1: return 'Solicitada'
      case 2: return 'Aceptada'
      case 3: return 'Rechazada'

      // Estados para flujo extendido
      case 4: return 'Enviado a Inspección'
      case 5: return 'Enviado Ministerio'
      case 6: return 'En Corrección'
      case 7: return type === 'consultorio_baja' ? 'Finalizado' : 'Habilitado'

      default: return '-'
    }
  }

  const setNewOrder = (field) => {
    // Si el campo elegido ya está seleccionado, sólo cambiamos el orden
    if (currentOrder && currentOrder.field === field) {
      changeOrder(
        currentOrder.field,
        currentOrder.dir === 1 ? -1 : 1
      )
    // Si es un nuevo campo, lo indicamos como seleccionado y reseteamos el orden
    // a ascendente
    } else {
      changeOrder(field, 1)
    }
  }

  /**
   * Configuración de la cabecera de las columnas
   */
  const columns = [
    {
      name: 'id',
      label: 'Solicitud',
      sort: true,
      value: row => {
        let type;
        switch (row.type) {
          case "account":
            type = 'Cuenta';
            break;
          case 'photo':
          case 'foto':
            type = 'Foto';
            break;
          case "profile":
          case "perfil":
            type = 'Datos';
            break;
          case "matricula":
            type = 'Matriculación';
            break;
          case "rematriculacion":
            type = 'Rematriculación';
            break;
          case "cancelation":
            type = 'Cancelación';
            break;
          case "suspension":
            type = 'Suspensión';
            break;
          case "baja":
            type = 'Baja';
            break;
          case "consultorio":
            type = 'Consultorio';
            break;
          case "consultorio_baja":
            type = 'Baja Consultorio';
            break;
          case "consultorio_renovacion":
            type = 'Renovación Consultorio';
            break;
          case "consultorio_update_edilicia":
          case "consultorio_update_director":
          case "consultorio_update_propietario":
            type = 'Modificación Consultorio';
            break;
          case "staff_multiple":
            type = 'Staff Múltiple';
            break;
          case "staff":
            type = 'Staff';
            break;
          case "staff_baja":
            type = 'Baja Staff';
            break;
          case "facturacion_ooss":
            type = 'Facturación OOSS';
            break;
          case "forma_pago":
            type = 'Forma de Pago';
            break;
          default:
            type = 'Datos';
        }
        return `${ type } #${ row.id }`
      }
    },
    {
      name: 'delegation',
      label: 'Delegación',
      sort: true,
      value: row => row.delegacion
    },
    {
      name: 'matriculate_id',
      label: 'Matrícula',
      sort: true,
      value: row => row.matriculate_id
    },
    {
      name: 'name',
      label: 'Nombre',
      sort: true,
      value: row => row.apellido && row.nombre ? `${ row.apellido }, ${ row.nombre }` : ''
    },
    {
      name: 'created_at',
      label: 'Fecha de Solicitud',
      sort: true,
      value: row => row.created_at ? moment(row.created_at).format('DD/MM/YYYY HH:mm') : '-'
    },
    {
      name: 'state_id',
      label: 'Estado',
      sort: false,
      value: row => row.state_id ? getStateName(row.state_id, row.type) : ' - '
    },
    {
      name: 'user_id',
      label: 'Usuario',
      sort: false,
      value: row => row.user ? `${ row.user.firstName } ${ row.user.lastName }` : ' - '
    },
    {
      name: 'actions',
      label: 'Acciones',
      value: row => {
        let type;
        switch (row.type) {
          case 'photo':
            type = 'photos';
            break;
          case "matricula":
            type = 'matriculas';
            break;
          default:
            type = row.type;
        }
        return (
          (row.state_id === 1) || (row.state_id < 7 && requestTypesWithExtendedFlow.includes(type))
          ? <Link to={`/admin/matriculates/${ type }/${ row.id }/edit`} className="btn btn-round btn-primary btn-sm">
              <i className="fa fa-edit"></i>
            </Link>
          : <Link to={`/admin/matriculates/${ type }/${ row.id }`} className="btn btn-round btn-primary btn-sm">
              <i className="fa fa-eye"></i>
            </Link>
        )
      }
    }
  ]

  return (
    <Table className="align-items-center table-flush" responsive id={ id }>
      <thead className="thead-light">
        <tr>
          {
            // Cabecera
            columns.map((column) => {
              if (!column.sort) {
                return <th key={column.name} scope='col' className={column.classes ?? ''}>{ column.label }</th>
              }

              return (
                <th key={column.name} scope='col' className={ `clickable ${column.classes ?? ''}` } onClick={ () => setNewOrder(column.name) }>
                  { column.label }
                  { <i className={ getIconClassBySorted(column.name) }></i> }
                </th>
              )
            })
          }
        </tr>
      </thead>
      <tbody>
        {
          // Datos
          !isLoading
          ? Array.isArray(items) && items.length
            ? items.map(row =>
              <tr key={ `request_${ row.type }_${ row.id }` }>
                { columns.map(column => <td key={ column.name } className={ column.classes ?? '' } >{ column.value(row) }</td>) }
              </tr>
            )
            : <tr>
                <td colSpan={columns.length + 1} className='text-center'>
                  <span>No se encontraron solicitudes</span>
                </td>
              </tr>
          : <tr>
              <td colSpan={columns.length + 1} className='text-center'>
                <TableLoader />
              </td>
            </tr>
        }
      </tbody>
    </Table>
  )
}